import { toastService } from "src/libraries/toast";
import { CreateCategoryDto } from "../entity/categories/dto/create-category-dto";
import { categoriesService } from "../entity/categories/CategoryService";
import { getCategoriesUseCase } from "./getCategoriesUseCase";

export const createCategoryUseCase = async (body: CreateCategoryDto) => {
    try {
        const formData = new FormData();
        Object.keys(body).forEach(key => {
            if (key === 'image' && body?.image) {
                formData.append('image', body.image, body.image.name)
            } else if (body[key] !== null && body[key] !== undefined) {
                formData.append(key, body[key].toString());
            }
        });
        const response = await categoriesService.create(formData);
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
            await getCategoriesUseCase({ tree: true });
        }
        return response;
    } catch (error) {
        console.warn('createCategoryUseCase: ', error);
    }
}  